import React, { Component } from "react";
import { withStyles } from "@material-ui/core/styles";
import TableContainer from "@material-ui/core/TableContainer";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import Paper from "@material-ui/core/Paper";

import { useStyles } from "../../../../Components/CSS/TableStyle.css";
import AdminHeader from "../../../../Components/NavBar/Admin/AdminHeader/AdminHeader";
import CustomTableHead from "../../../../Components/Table/CustomTableHeader/CustomTableHeader";
import CustomTableFooter from "../../../../Components/Table/CutomTableFooter/CustomTableFooter";
import PageTitle from "../../../../Components/PageTitle/PageTitle";
import CustomSiteLoader from "../../../../Components/CustomSiteLoader/CustomSiteLoader";
import CustomEmptyMessage from "../../../../Components/CustomEmptyMessage/CustomEmptyMessage";
import { withRouter } from "react-router-dom";
import { connect } from "react-redux";
import InventoryBody from "../InventoryBody/InventoryBody";
import InventoryFilter from "../InventoryFilter/InventoryFilter";
import { url } from "../../../../Config/Config";
import Axios from "axios";
import { getAdminRefreshToken } from "../../../../Redux/Actions/actions";
import CustomBreadCrumbs from "../../../../Components/CustomBreadCrumbs/CustomBreadCrumbs";

class ViewInventory extends Component {
  constructor(props) {
    super(props);
    this.state = {
      rowsPerPage: 10,
      page: 0,
      search: {
        categoryName: "",
      },
      detailStatus: false,
      detailData: [],
      column: [
        { name: "S.N." },
        { name: "Category Name" },
        { name: "Current Stock" },
        { name: "Actions" },
      ],
      categories: [],
      isEmpty: false,
    };
  }

  componentDidMount() {
    this.getItemCategories();
  }

  getItemCategories = async () => {
    try {
      const response = await Axios.get(`${url}/api/item-categories`, {
        headers: {
          Authorization: `Bearer ${this.props.adminToken}`,
        },
      });
      if (response.data.itemCategories.length !== 0) {
        this.setState({
          categories: response.data.itemCategories,
          isEmpty: false,
        });
      } else {
        this.setState({
          categories: [],
          isEmpty: true,
        });
      }
    } catch (error) {
      if (
        error.response.data === "jwt expired" &&
        error.response.status === 401
      ) {
        console.clear();
        let refreshToken = { refreshToken: this.props.refreshToken };
        this.props.getAdminRefreshToken(refreshToken, this.props.role);
        this.getItemCategories();
      }
    }
  };

  handleDetailStatus = (detailData) => {
    this.setState({
      detailStatus: true,
      detailData,
    });
  };

  handleCancelDetail = () => {
    this.setState({
      detailStatus: false,
    });
  };

  handleSearch = (e) => {
    this.setState({
      search: {
        ...this.state.search,
        [e.target.name]: e.target.value,
      },
    });
  };

  handlePage = (e, newPage) => {
    this.setState({
      page: newPage,
    });
  };

  handleRowsPerPage = (e) => {
    this.setState({
      rowsPerPage: +e.target.value,
      page: 0,
    });
  };

  render() {
    const { classes } = this.props;
    const { rowsPerPage, page } = this.state;
    const filtered = this.state.categories.filter((item) => {
      return (
        item.categoryName
          .toLowerCase()
          .indexOf(this.state.search.categoryName.toLowerCase()) !== -1
      );
    });
    return (
      <div className={classes.root}>
        <AdminHeader />
        <div className={classes.content}>
          <div className={classes.toolbar} />

          <CustomBreadCrumbs url={this.props.match.url} />
          <PageTitle
            title="Inventory List"
            refreshUrl={this.props.match.url}
            addUrl={"/administration/inventory/add"}
            urlTitle="Add Inventory's Item"
          />
          {this.state.categories.length !== 0 && (
            <InventoryFilter
              data={this.state.search}
              handleSearch={this.handleSearch}
            />
          )}
          <br />

          {this.state.categories.length !== 0 ? (
            <Paper>
              <TableContainer>
                <Table>
                  <CustomTableHead column={this.state.column} />

                  <TableBody>
                    {(rowsPerPage > 0
                      ? filtered.slice(
                          rowsPerPage * page,
                          rowsPerPage * page + rowsPerPage
                        )
                      : filtered
                    ).map((grade, index) => (
                      <InventoryBody
                        data={grade}
                        key={index}
                        index={index}
                        handleDetailStatus={this.handleDetailStatus}
                        getItemCategories={this.getItemCategories}
                      />
                    ))}
                  </TableBody>

                  <CustomTableFooter
                    count={filtered.length}
                    rowsPerPage={rowsPerPage}
                    page={page}
                    onChangePage={this.handlePage}
                    onChangeRowsPerPage={this.handleRowsPerPage}
                  />
                </Table>
              </TableContainer>
            </Paper>
          ) : this.state.isEmpty ? (
            <CustomEmptyMessage />
          ) : (
            <CustomSiteLoader />
          )}
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    adminToken: state.AdminReducer.adminToken,
    refreshToken: state.AdminReducer.refreshToken,
    role: state.AdminReducer.role,
    isAdmin: state.AdminReducer.isAdmin,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    getAdminRefreshToken: (refreshToken, role) => {
      dispatch(getAdminRefreshToken(refreshToken, role));
    },
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withStyles(useStyles)(withRouter(ViewInventory)));
